import { createReducer } from "@reduxjs/toolkit";
import { showVersionMismatch } from "@shared-kernel/application/use-cases/show-version-mismatch/show-version-mismatch";

export const showVersionMismatchReducer = createReducer(false, builder => {
  builder.addCase(showVersionMismatch, () => true);
});
